import { message, Progress, Skeleton } from "antd";
import { IoCopy } from "react-icons/io5";
import { copyToClipboard, shortenAddress } from "../../helpers";
import Countdown from "react-countdown";
import { NFTType } from "../../type";
import { NFTMintedState } from "../../type/enum";
import { useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
const NFTCard = ({
  nftData,
  mintState,
  handleMintNFTClick,
  loading,
  mintedId,
}: {
  nftData?: NFTType;
  mintState: NFTMintedState;
  handleMintNFTClick: (_address: string) => void;
  loading: boolean;
  mintedId: string | undefined;
}) => {
  const { openConnectModal } = useConnectModal();

  const percent_total = nftData?.total_supply
    ? Number((Number(nftData.total_minted) / nftData.total_supply).toFixed(4)) *
      100
    : 0;
  const endTime = nftData?.end_time
    ? new Date(nftData.end_time).getTime()
    : undefined;
  const startTime = nftData?.start_time
    ? new Date(nftData.start_time).getTime()
    : undefined;
  const currentTime = new Date().getTime();

  const { address } = useAccount();

  return (
    <div className="pb-10 w-full flex flex-col lg:flex-row items-start gap-7 font-Montserrat">
      <div className="w-full lg:w-[35%] xl:w-[30%] self-stretch flex justify-center">
        <div className="w-full sm:w-4/5 md:w-3/5 lg:w-full aspect-[calc(200/250)] h-auto relative p-5 bg-gradient-to-t from-[rgba(0,148,255,0.6)] to-[rgb(255,255,255)]">
          {nftData?.image && (
            <video
              id="headerVideo"
              className="h-full w-full object-cover"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={nftData?.image} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {mintedId && (
            <div
              className="px-5 rounded-lg bg-gradient-to-r from-[rgb(60,140,231)] to-[rgb(0,234,255)] border border-white
             absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 font-Azonix text-white font-medium text-xl tracking-[2px]"
            >
              #{nftData?.id}
            </div>
          )}
        </div>
      </div>
      <div className="w-full lg:w-[65%] xl:w-[70%] self-stretch flex flex-col items-start text-text-primary gap-3 bg-backgroundWhite pt-5 pb-6 px-6 rounded-lg">
        {loading ? (
          <>
            <Skeleton active paragraph={{ rows: 4 }} title={{ width: "50%" }} />

            <div className="mt-5 w-full flex justify-center">
              <Skeleton.Button active shape="square" size="large" />
            </div>
          </>
        ) : (
          <>
            <div className="font-semibold text-xl sm:text-2xl md:text-3xl 2xl:text-4xl font-Azonix">
              {nftData?.name}
            </div>
            <p className="mt-2 text-start text-sm xl:text-base whitespace-pre-wrap">
              {nftData?.description}
            </p>
            <div className="text-base xl:text-lg">
              Creator: <span className="font-semibold">TinyBlock</span>
            </div>
            <div className="w-full flex items-center justify-between">
              <div className="text-base xl:text-lg">
                Progress:{" "}
                <span className="text-customBlue-500 font-bold">
                  {percent_total.toFixed(2)}%
                </span>
              </div>
              <div className="text-base xl:text-lg">
                <span className="text-customBlue-500 font-bold">
                  {(nftData?.total_minted ?? 0).toLocaleString("en-US")}
                </span>
                /{" "}
                <span className="font-semibold">
                  {(nftData?.total_supply ?? 0).toLocaleString("en-US")} NFTs
                </span>
              </div>
            </div>
            <div className="w-full">
              <Progress
                percent={percent_total}
                percentPosition={{ align: "center", type: "inner" }}
                size={["100%", 20]}
                strokeColor={{ from: "#3C8CE7", to: "#00EAFF" }}
              />
            </div>
            <div className="w-full flex gap-4 text-left">
              <div className="flex-1 basis-[calc((100%-2rem)/3)]">
                <p>Contract Address</p>
                <div className="flex gap-3 items-center">
                  <div className="font-semibold text-base xl:text-lg">
                    {shortenAddress(nftData?.nft_address || "")}
                  </div>
                  <IoCopy
                    onClick={() => copyToClipboard(nftData?.nft_address || "")}
                    className="cursor-pointer text-[#292D32]"
                    size={18}
                  />
                </div>
              </div>

              <div className="flex-1 basis-[calc((100%-2rem)/3)]">
                <p>Total Supply</p>
                <p className="font-semibold text-lg">
                  {(nftData?.total_supply ?? 0).toLocaleString("en-US")}
                </p>
              </div>

              <div className="flex-1 basis-[calc((100%-2rem)/3)]">
                <p>Total Minted</p>
                <p className="font-semibold text-lg">
                  {(nftData?.total_minted ?? 0).toLocaleString("en-US")} NFTs
                </p>
              </div>
            </div>
            <div
              className="w-fit flex gap-3 items-center font-Azonix mt-2 font-bold text-base sm:text-lg leading-[1] tracking-[1.5px]
          bg-gradient-to-r from-[rgb(60,140,231)] to-[rgb(0,234,255)] text-transparent bg-clip-text"
            >
              {!startTime || !endTime || currentTime < startTime
                ? "Starts In"
                : currentTime < endTime
                  ? "Ends In"
                  : "Ended"}
              <div className="">
                {endTime && startTime ? (
                  currentTime < endTime ? (
                    <Countdown
                      date={currentTime < startTime ? startTime : endTime}
                      renderer={({
                        days,
                        hours,
                        minutes,
                        seconds,
                        completed,
                      }: any) => (
                        <>
                          {completed ? "00" : days}D: {completed ? "00" : hours}
                          H: {completed ? "00" : minutes}M:{" "}
                          {completed ? "00" : seconds}S
                        </>
                      )}
                    />
                  ) : (
                    ""
                  )
                ) : (
                  <>TBA</>
                )}
              </div>
            </div>
            <div className="mt-3 w-full flex justify-center">
              {address && startTime && endTime ? (
                mintState === NFTMintedState.MINTED ? (
                  <div className="w-[200px] py-2 rounded-sm font-bold text-lg bg-gradient-to-tr bg-[#0094FF1A] text-customBlue-500">
                    MINTED
                  </div>
                ) : mintState === NFTMintedState.CLAIMABLE ? (
                  currentTime < startTime ? (
                    <div className="bg-[#E5E5E5] text-[#7891A5] w-fit px-4 py-2 rounded-sm font-bold text-base uppercase">
                      Mint has not started
                    </div>
                  ) : currentTime > endTime ? (
                    <div className="bg-[#E5E5E5] text-[#7891A5] w-fit px-4 py-2 rounded-sm font-bold text-base uppercase">
                      Mint ended
                    </div>
                  ) : (
                  <button
                    className="main-button w-200 !text-lg !py-2"
                    onClick={() => handleMintNFTClick(address)}
                  >
                    MINT NFT
                  </button>
                )
                ) : (
                  <div className="bg-[#E5E5E5] text-[#7891A5] w-fit px-4 py-2 rounded-sm font-bold text-base uppercase">
                    You're not whitelisted
                  </div>
                )
              ) : (
                <button
                  className="main-button w-200"
                  onClick={openConnectModal}
                >
                  Connect wallet
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NFTCard;
